import { addToolbar } from '@eworx/ckeditor5/toolbars';
import baseToolbars from '@eworx/ckeditor5/toolbars';

import { isCampaignEditor } from './utils';
export default function registerToolbars(config) {
    var fckLinkToolbarItemName = "basicLink";

    if (parent.location.href.toLowerCase().indexOf("centralsection/") > -1
        || parent.location.href.toLowerCase().indexOf("/edittemplatedefaultvalues.aspx") > -1 ||
        isCampaignEditor()) {
        fckLinkToolbarItemName = "statisticLink";

        if (config.removePlugins) {
            config.removePlugins.push('Link', 'LinkImage', 'BasicLink');
        }
        else {
            config.removePlugins = ['Link', 'LinkImage', 'BasicLink'];
        }
    }
    else {
        if (config.removePlugins) {
            config.removePlugins.push('StatisticLink', 'StatisticLinkEditing', 'StatisticLinkImageEditing');
        }
        else {
            config.removePlugins = ['StatisticLink', 'StatisticLinkEditing', 'StatisticLinkImageEditing'];
        }
    }

    var toolbarItems = [fckLinkToolbarItemName, 'insertTable', 'emoji', 'mdbImage', 'horizontalLine', 'specialCharacters', '|'];

    // "Default" toolbars
    addToolbar('Default', [
        'sourceEditing', '|',
        'undo', 'redo', /* 'spellCheck', */, 'formatPainter', 'removeFormat', '|',
        ...toolbarItems,
        'bold', 'italic', 'underline', 'strikethrough', '|', 'alignment', '|',
        'subscript', 'superscript', '|',
        'numberedList', 'bulletedList', '|',
        'outdent', 'indent', '|',
        'placeholderChooser',
    ]);
    addToolbar('DefaultWithStyle', [...baseToolbars.Default, '|', 'heading']);

    addToolbar('Extended', [
        'sourceEditing', '|',
        'undo', 'redo', /* 'spellCheck', */ 'formatPainter', 'removeFormat', '|',
        ...toolbarItems,
        'fontColor', 'fontFamily', 'fontSize', 'lineHeight', '|',
        'bold', 'italic', 'underline', 'strikethrough', '|', 'alignment', '|',
        'subscript', 'superscript', '|',
        'numberedList', 'bulletedList', '|',
        'outdent', 'indent', '|',
        'placeholderChooser',
    ]);
    addToolbar('ExtendedWithStyle', [...baseToolbars.Extended, '|', 'heading']);

    addToolbar('DefaultRestricted', [
        'sourceEditing', '|',
        'undo', 'redo', /* 'spellCheck', */ 'formatPainter', 'removeFormat', '|',
        'bold', 'italic', 'underline', 'strikethrough', '|', 'alignment', '|',
        'subscript', 'superscript', '|',
        'numberedList', 'bulletedList', '|',
        'outdent', 'indent', '|',
        'placeholderChooser'
    ]);
    addToolbar('DefaultRestrictedWithStyle', [...baseToolbars.DefaultRestricted, '|', 'heading']);

    addToolbar('DefaultWKOOE', [
        'undo', 'redo', /* 'spellCheck', */ 'formatPainter', 'removeFormat', '|',
        fckLinkToolbarItemName, /* 'unlink', */ 'insertTable', 'specialCharacters', '|',
        'bold', '|', 'alignment', '|',
        'subscript', 'superscript', '|',
        'numberedList', 'bulletedList', '|',
        'outdent', 'indent', '|',
        'placeholderChooser'
    ]);
    addToolbar('DefaultWKOOEWithStyle', [...baseToolbars.DefaultWKOOE, '|', 'heading']);

    // "Basic" toolbars
    addToolbar('Basic', [
        'sourceEditing', '|',
        'bold', 'italic', 'underline', 'strikethrough', '|',
        'subscript', 'superscript'
    ]);
    addToolbar('BasicRestricted', [
        'sourceEditing', '|',
        'undo', 'redo', /* 'spellCheck', */ 'formatPainter', 'removeFormat', '|',
        'bold', 'italic', 'underline', 'strikethrough'
    ]);

    // BasicRestrictedWithPlaceholder is part of the "Default" toolbarset
    // configure "WithStyle" as well (for campaign editor)
    addToolbar('BasicRestrictedWithPlaceholder', [...baseToolbars.BasicRestricted, '|', 'placeholderChooser']);
    addToolbar('BasicRestrictedWithPlaceholderWithStyle', [...baseToolbars.BasicRestrictedWithPlaceholder, '|', 'heading']);

    let fontStylingItems = [];
    if (window.location.hash.toLowerCase().indexOf("#/landingpages/editor") === 0) {
        // allow editing fontFamily, fontSize and lineHeight in landing page editor
        fontStylingItems = ['fontFamily', 'fontSize', 'lineHeight'];
    }
    else if (window.location.hash.toLowerCase().indexOf("#/eventlayouts/editor") === 0) {
        // allow editing fontFamily, fontSize and lineHeight in landing page editor
        fontStylingItems = ['fontFamily', 'fontSize', 'lineHeight'];
    }

    // "PageEditor" toolbars
    addToolbar('PageEditor', [
        'sourceEditing', '|',
        'undo', 'redo', /* 'spellCheck', */'formatPainter', 'removeFormat', '|',
        ...toolbarItems,
        'bold', 'italic', 'underline', 'strikethrough', '|', 'alignment', '|',
        'subscript', 'superscript', '|',
        'numberedList', 'bulletedList', '|',
        'outdent', 'indent', '|',
        'fontColor', 'fontBackgroundColor', ...fontStylingItems, '|',
        'placeholderChooser'
    ]);
    addToolbar('PageEditorRestricted', [
        'sourceEditing', '|',
        'undo', 'redo', /* 'spellCheck', */ 'formatPainter', 'removeFormat', '|',
        ...toolbarItems,
        'bold', 'italic', 'underline', 'strikethrough', '|', 'alignment', '|',
        'subscript', 'superscript', '|',
        'numberedList', 'bulletedList', '|',
        'outdent', 'indent', '|',
        'placeholderChooser'
    ]);
    addToolbar('PageEditorHeadline', [
        'sourceEditing', '|',
        'undo', 'redo', /* 'spellCheck', */'formatPainter', 'removeFormat', '|',
        ...toolbarItems.filter(function(item) { return ['insertTable', 'mdbImage', 'horizontalLine'].indexOf(item) < 0; }),
        'bold', 'italic', 'underline', 'strikethrough', '|', 'alignment', '|',
        'subscript', 'superscript', '|',
        'fontColor', 'fontBackgroundColor', ...fontStylingItems, '|',
        'placeholderChooser'
    ]);
    addToolbar('PageEditorHeadlineRestricted', [
        'undo', 'redo', /* 'spellCheck', */ 'formatPainter', 'removeFormat', '|',
        ...toolbarItems.filter(function(item) { return ['insertTable', 'mdbImage', 'horizontalLine'].indexOf(item) < 0; }),
        'bold', 'italic', 'underline', 'strikethrough', '|', 'alignment', '|',
        'subscript', 'superscript', '|',
        'placeholderChooser'
    ]);

    // other toolbars
    addToolbar('Textcomponent', [
        'sourceEditing', '|',
        'link', /* 'unlink', */'insertTable', 'emoji', 'mdbImage', '|',
        'bold', 'italic', 'underline', 'strikethrough', '|',
        'subscript', 'superscript', '|',
        'numberedList', 'bulletedList', '|',
        'placeholderChooser'
    ]);
    addToolbar('BasicFormEditor', [
        /*'sourceEditing', '|',*/ //Not supported for inline editor at the moment
        'bold', 'italic', 'underline',
        'link', /* 'unlink', */ '|',
        'subscript', 'superscript', '|',
        'placeholderChooser'
    ]);
    addToolbar('UserNotification', [
        'undo', 'redo', /* 'spellCheck', */ 'formatPainter', 'removeFormat', '|',
        'bold', 'italic', 'underline', 'strikethrough', '|', 'alignment', '|',
        'outdent', 'indent'
    ]);
};